<div class="flex min-h-40 flex-col gap-4">
  <div class="flex-1 space-y-2">
    <div class="mb-2 text-sm font-medium">Select a brand to import targetings from</div>
    <ISelectMenu [value]="selectedBrand()" (valueChange)="selectBrand($event)" by="brandId" fitTriggerWidth>
      <ISelectTrigger class="flex w-full">
        <ISelectValue placeholder="Select Brand">
          <div *iSelectValue="let value">{{ value?.brandAlias }}</div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (brand of brands(); track brand.brandId) {
          <ISelectOption [value]="brand">
            {{ brand.brandAlias }}
          </ISelectOption>
        }
      </ISelectContent>
    </ISelectMenu>

    @if (selectedTargetings(); as targetings) {
      <div>
        <p class="mt-2 text-gray-600">
          {{ targetings.keywords.length }} keywords and {{ targetings.products.length }} products will be imported
        </p>
      </div>
    }
  </div>
  <div class="flex justify-end gap-x-2">
    <button iButton variant="secondary" size="md" (click)="close()">Cancel</button>
    <button iButton size="md" class="w-1/5" [disabled]="!selectedTargetings()" (click)="emit()">Import</button>
  </div>
</div>
